module.exports = globalThis.config = {
    Settings: {
        welcome: {
            en: "Welcome",
            fa: "خوش آمدید"
        },
        Locale: 'en',
        ApiConfiguration: {
            //"Appurl": "http://localhost:3000/",
            // "Appurl": "http://corp-sqldb:85/",
            //"Appurl": "http://localhost/AssamPMIS/",
            // "Appurl": "http://corp-sqldb:85/",
            //"Appurl": "https://150.230.51.41:4435/",
            "Appurl": "https://pmis.assamforestwatch.com/",
            //"Appurl": "http://corp-sqldb/PMIS/",
            //"Host": "http://corp-sqldb/",   
            "Host": "https://assamforestwatch.com/",
            //"Appurl": "https://115.124.116.252/AssamPMIS/",
            //"Host": "https://115.124.116.252/",
            //"Appurl": "https://10.48.155.142:4436/", 
            //"Host": "https://10.48.155.142/",
            //"BaseURL": "/AssamPMIS",     
            "HelpURL": "https://assamforestwatch.com/Microservices/PMISHelp/",
            "BaseURL": "",
            "APIGateway": "https://corp-sqldb/api/gateway",
            "UploadMaxFiles": 3,
            "GJSON": {},
            "SSO_urls": {
                "GIS": "https://geoportal.rmsi.com/GIS/",
                "FMIS": "https://geoportal.rmsi.com/AssamFMIS/"
            },
            "User": {
                "UserName": "",
                "jwtToken": "",
                "ExpiredIn": "",
                "userid": "",
                "emailId": "",
                "applicanttype_Id": "",
                "mobile_number": "",
                "userdetail_id": ""
            },
            "Microservices": {
                "Common": "/Microservices/Common/",
                "PMIS": "/Microservices/PMIS/",
                "Nursery": "/Microservices/nursery",
                "TOF": "/Microservices/TOF/",
            },
            "Permissions": "",
            "toast_life": 5000
        },

        token: '',
        security_key: '48271710799bc4816a4673a364a130f5e8825bc0d49e57638bd5025240f8e535431ad105a21e6b2235451812acd15ecc3eafd4e1d6fc093d49f34cbabb625e89',

        MapConfig: {
            PortalUrl: "https://portal.assamforestwatch.com/gisportal/",
            ServerUrl: "https://portal.assamforestwatch.com/gisserver",
            ID: "446cf1a848954f5c98f4c5c6fd440495",
            IdentifyTaskUrl: "https://portal.assamforestwatch.com/gisserver/rest/services/Assam-UAT/ForestBoundaries_UAT/MapServer/",
            QueryTaskUrl: "https://portal.assamforestwatch.com/gisserver/rest/services/Assam-UAT/AdminBoundaries_UAT/FeatureServer/1",
            AssamAdminBoundary: "https://portal.assamforestwatch.com/gisserver/rest/services/Assam-UAT/AdminBoundaries_UAT/FeatureServer/1",
            ForestBoundariesUrl: "https://portal.assamforestwatch.com/gisserver/rest/services/Assam-UAT/ForestBoundaries_UAT/MapServer/",
            dashboard_url: "https://portal.assamforestwatch.com/gisserver/rest/services/Assam-Prod/pmis_PlantationSites/MapServer/0",
            baseURL: 'https://portal.assamforestwatch.com/gisportal/sharing/rest/',
            ForestBoundariesMapServerUrl: "https://portal.assamforestwatch.com/gisserver/rest/services/Assam-UAT/ForestBoundaries_UAT/MapServer/",
            GenerateShapeUrl: "https://portal.rmsi.com/portal114/sharing/rest/content/features/generate",
            //GenerateShapeUrl: "https://portal.assamforestwatch.com/gisportal/sharing/rest/content/features/generate",
            GetTokenBaseUrl: "https://portal.assamforestwatch.com/gisportal/sharing/rest/",
            CreateUserBaseUrl: "https://portal.assamforestwatch.com/gisportal/portaladmin/security/users/",
            ForestBoundary: "https://portal.assamforestwatch.com/gisserver/rest/services/Assam-UAT/ForestBoundaries_UAT/MapServer/",
            PlotPointLayer: "https://portal.assamforestwatch.com/gisserver/rest/services/Assam-Prod/PMIS_PlantationInspectionPlot_Points/MapServer/0",
            PlotGridLayer: "https://portal.assamforestwatch.com/gisserver/rest/services/Assam-Prod/PMIS_PlantationInspectionPlot_Points/MapServer/1",
            ApiVersion: "4.29",
            //Wing wise Division & Range
            Wingwise_Division: "https://portal.assamforestwatch.com/gisserver/rest/services/Assam-Prod/ForestBoundaryProd_RefView/MapServer/0",
            Wingwise_Range: "https://portal.assamforestwatch.com/gisserver/rest/services/Assam-Prod/ForestBoundaryProd_RefView/MapServer/1"
            //Wing wise Division & Range
        },
        // MapConfig: {
        //     PortalUrl: "https://geoportal.rmsi.com/arcportal11/",
        //     ServerUrl: "https://geoportal.rmsi.com/arcserver11",
        //     ID: "f20d570134fa45ce8e6731d33deada45",
        //     IdentifyTaskUrl: "https://geoportal.rmsi.com/arcserver11/rest/services/Assam/ForestBoundaries/MapServer/",
        //     QueryTaskUrl: "https://geoportal.rmsi.com/arcserver11/rest/services/Assam/AdminBoundaries/MapServer/1",
        //     AssamAdminBoundary: "https://geoportal.rmsi.com/arcserver11/rest/services/Assam/AdminBoundaries/MapServer/1",
        //     ForestBoundariesUrl: "https://geoportal.rmsi.com/arcserver11/rest/services/Assam-STG/ForestBoundariesSTGLayerNew/MapServer/0",
        //     dashboard_url: "https://geoportal.rmsi.com/arcserver11/rest/services/Assam/pmis_PlantationSites/MapServer/0",
        //     baseURL: 'https://geoportal.rmsi.com/arcportal11/sharing/rest/',
        //     ForestBoundariesMapServerUrl: "https://geoportal.rmsi.com/arcserver11/rest/services/Assam-STG/ForestBoundariesSTGLayerNew/MapServer",
        //     GenerateShapeUrl: "https://geoportal.rmsi.com/arcportal11/sharing/rest/content/features/generate",
        //     GetTokenBaseUrl: "https://geoportal.rmsi.com/arcportal11/sharing/rest/",
        //     CreateUserBaseUrl: "https://geoportal.rmsi.com/arcportal11/portaladmin/security/users/",
        //     ForestBoundary: "https://geoportal.rmsi.com/arcserver11/rest/services/Assam/NewForestBoundariesDevelopmentEnv/MapServer",
        //     PlotPointLayer: "https://geoportal.rmsi.com/arcserver11/rest/services/Assam-STG/PMIS_PlantationInspectionPlot_Points/MapServer/0",
        //     PlotGridLayer: "https://geoportal.rmsi.com/arcserver11/rest/services/Assam-STG/PMIS_PlantationInspectionPlot_Points/MapServer/1",
        //     ApiVersion: "4.29",
        //     //Wing wise Division & Range
        //     Wingwise_Division: "https://portal.assamforestwatch.com/gisserver/rest/services/Assam-Prod/ForestBoundaryProd_RefView/MapServer/0",
        //     Wingwise_Range: "https://portal.assamforestwatch.com/gisserver/rest/services/Assam-Prod/ForestBoundaryProd_RefView/MapServer/1"
        //     //Wing wise Division & Range
        // },
        max_file_size_options: {
            image: '5 MB',
            video: '20 MB',
            pdf: '5 MB',
            doc: '5 MB',
        }
    }
};